import { useMemo } from 'react'
import { DashBoardValue } from '../../../../../hooks'
import { DashBoardItemOption, GraphDirection } from '../../../../../types'
import { GraphOptions, getAxisDef, getValueDef } from '../../common'

import {
  Percent as PercentIcon,
  Sort as SortIcon
} from '@mui/icons-material'
import { TargetListResult } from "interface/search/targetList"

export const BarGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis',
      type: 'axis',
      label: '軸',
      suffix: 'ごとの'
    }, {
      id: 'value',
      type: 'value',
      label: '値'
    }, {
      id: 'formula',
      type: 'choice',
      label: '集計式',
      data: [
        { label: '合計', value: 'sum', showOnTitle: false },
        { label: '平均', value: 'ave' },
        { label: '最大', value: 'max' },
        { label: '最小', value: 'min' },
      ],
      default: 'sum',
      prefix: 'の',
    }, { 
      id: 'stack',
      type: 'axis',
      label: '色分け',
      nullable: true,
      prefix: 'を',
      suffix: 'で色分け'
    },
  ],
  [
    {
      id: 'is100',
      type: 'check',
      label: '100%',
      default: 'false',
      toolBtn: <PercentIcon fontSize="small"/>
    },
    {
      id: 'sort',
      type: 'check',
      label: '並び替え',
      default: 'false',
      toolBtn: <SortIcon fontSize="small"/>
    },
    {
      id: 'fixMax',
      type: 'check',
      label: '最大値固定',
      default: 'false'
    }
  ]
]

type useBarGraphOptionProps<T> = {
  direction: GraphDirection
  dashBoard: DashBoardValue<T>
  options?: DashBoardItemOption[]
  targetList?: TargetListResult
}
export const useBarGraphOption = <T,>({
  direction,
  dashBoard: {
    configure,
    globalAxisKey
  },
  options,
  targetList
}: useBarGraphOptionProps<T>) => useMemo(
  () => ({
    direction, configure, options, targetList,
    axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
    valueDef: getValueDef(configure, options, 'value', targetList),
    stackDef: getAxisDef(configure, options, 'stack', globalAxisKey, targetList),
    formula: options?.find(opt => opt.id === 'formula')?.value,
    is100: options?.find(opt => opt.id === 'is100')?.value === 'true',
    sort: options?.find(opt => opt.id === 'sort')?.value === 'true',
    fixMax: options?.find(opt => opt.id === 'fixMax')?.value === 'true'
  }),
  [direction, options, configure, globalAxisKey, targetList]
)
